// sse/SSEProvider.tsx
import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { EventMap, SSEHub } from '../lib/sse/SSEHub';
import { AppContext } from '../sporttia/AppContext';

// undefined: fuera del provider; null: sin usuario, no hay stream
const Ctx = createContext<SSEHub | null | undefined>(undefined);

export function SSEProvider({ children }: { children: React.ReactNode }) {
    const { user } = useContext(AppContext) ?? {};
    const { apiEnv } = window.runtimeConfig;

    // Solo crea el hub si existe user
    const hub = useMemo(() => {
        if (!user?.id) return null;
        return new SSEHub(() => `${apiEnv.url}/v7/stream?userId=${user.id}`);
    }, [user?.id, apiEnv]);

    useEffect(() => {
        if (hub) {
            hub.start();
            return () => hub.stop();
        }
        // si no hay hub, no hacemos nada
    }, [hub]);

    return <Ctx.Provider value={hub}>{children}</Ctx.Provider>;
}

export function useSSE<E extends keyof EventMap>(
    event: E,
    handler: (data: EventMap[E]) => void,
) {
    const hub = useContext(Ctx);
    if (hub === undefined) {
        throw new Error('useSSE must be used inside SSEProvider');
    }

    React.useEffect(() => hub?.on(event, handler), [hub, event, handler]);
}
